export default function navDropHeight() {
  var windowHeight = window.innerHeight;
  if (window.innerWidth > 767 && !(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
    $('.nav-drop-holder').css('height', windowHeight - 262);
  } else {
    $('.nav-drop-holder').css('height', windowHeight - 72);
  }
}